<template>
  <Transition name="modal">
    <slot></slot>
  </Transition>
</template>

<style lang="scss">
.modal-enter-active,
.modal-leave-active {
  transition: all 0.2s ease-in-out;
}

.modal-leave-to {
  :deep(.modal-content) {
    animation: remove-content 0.3s ease-in-out;
  }
}

@keyframes remove-content {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0);
  }
}

@keyframes remove-background {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
